<template>
	<div
		class="
			[&>*]:text-sm [&_*]:text-secondary sm:[&>*]:text-base
			[&_h1]:text-xl [&_h1]:mb-4 [&_h1]:font-medium
			[&_h2]:text-lg [&_h2]:mb-3 [&_h2]:font-medium
			[&_h3]:text-base [&_h3]:mb-2 [&_h3]:font-medium [&_h3]:normal-case
			[&_h4]:text-sm [&_h4]:mb-2 [&_h4]:font-medium [&_h4]:mt-0
			[&_h5]:text-sm [&_h5]:mb-1.5 [&_h5]:font-normal
			[&_p]:text-sm [&_p]:my-3
			[&_ul]:list-disc [&_ul]:ml-5 [&_ul]:my-3
			[&_ol]:list-decimal [&_ol]:ml-6 [&_ol]:my-3
			[&_li]:my-1
			[&_strong]:font-semibold [&_strong]:text-sm sm:[&_strong]:text-base
			[&_a]:text-primary [&_a]:underline
			[&_em]:italic
		"
	>
		<slot />
	</div>
</template>
